import Stack from '@mui/material/Stack';
import { Link } from 'gatsby';
import React from 'react';
import If from './If';
import Image from './Image';
import { TypeOcr } from './Types';

interface BlogCardProps {
  blog: any;
  size?: string;
}

export default function BlogCardSmall(props: BlogCardProps) {
  const link = '/blogs/loquelic-literitas-the-blog/' + props.blog.handle;
  const image = props.blog.image || {};
  const alt = props.blog.image?.altText || 'blog summary';
  const title = props.blog.title;
  const show = props.blog.image != undefined;

  return (
    <>
      <Link to={link} color='info.main'>
        <Stack ml={1} alignItems='center' justifyContent='right'>
          <If value={show}>
            <Image
              className='blog-card'
              src={image.src_md}
              alt={image.altText}
              height={220}
              width={220}
            />
          </If>
          <TypeOcr fontSize={14} align='center' width='40%'>
            {title}
          </TypeOcr>
        </Stack>
      </Link>
    </>
  );
}
